import { CalendarPlus } from 'lucide-react';
import type { CriacaoWeb, PropsCriacao } from '../../nucleo/modulos-web';
import { FormReuniaoLivre } from './FormReuniaoLivre';

/**
 * Rodada rrl-1 (SPEC-M1, item 4 da ficha 2026-11-03): reunião livre pelo botão flutuante, com o vínculo da página aberta (contato,
 * empresa, negociação), sem campo a preencher. O contato vem antes da empresa dele: foi na ficha do contato que a pessoa abriu.
 */
function CriarReuniao({ aoFechar, contexto }: PropsCriacao) {
  const parceiroId = contexto.contato?.id ?? contexto.empresa?.id ?? contexto.negociacao?.parceiro_id ?? null;
  return <FormReuniaoLivre parceiroId={parceiroId} oportunidadeId={contexto.negociacao?.id ?? null} aoFechar={aoFechar} />;
}

export const criacoesAgenda: CriacaoWeb[] = [{ chave: 'reuniao', rotulo: 'criacao.itens.reuniao', icone: CalendarPlus, permissao: 'agenda.criar', subsistemas: ['crm'], posicao: 25, componente: CriarReuniao }];
